// import React from 'react';

// This component now returns null (nothing) since we're enforcing dark mode only
const ThemeToggle = () => {
  return null;
};

export default ThemeToggle;
